<template>
  <div class="app-container" >
    <!-- <shangYeXian></shangYeXian> -->
    <el-tabs v-model="activeName" >
      <el-tab-pane label="商业险" name="one" style="">
        <shangYeXian v-if="activeName=='one'"></shangYeXian>
      </el-tab-pane>
      <el-tab-pane label="社保" name="two">
        <sheBao v-if="activeName=='two'"></sheBao>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import shangYeXian from '@/views/newTMS/costExpense/driverInsurance/shangYeXian.vue'
import sheBao from '@/views/newTMS/costExpense/driverInsurance/sheBao.vue'
export default {
  components: {
    shangYeXian, sheBao
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
